import "./auth.css"
import logo from '../../assets/logo-light.svg'
import login from '../../assets/login.png'
import { Outlet } from "react-router-dom";
import ThemeToggle from "../../components/ThemeToggle";

export default function AuthFrame() {
    
    const goToWebsite = () => {
        window.location.href = 'https://mentormatches.ai';
    }
    
    return(
        <div className="full-screen-page grid auth-root relative">
            <div className="relative">
                <div className="absolute w-100 flex space-between center standard-padding-s">
                    <button className="text with-icon leading" onClick={goToWebsite}><span className="material-symbols-outlined scale-xs">undo</span> Back To Website</button>
                    <div className="flex center gap-m">
                        <ThemeToggle className={'text'}/>
                        <img src={logo} className="logo h-spacer-s"></img>
                    </div>
                </div>
                <div className="h-100 flex center justify-center login-wrapper standard-padding">
                    <Outlet/>
                </div>
            </div>
            <div className="w-100 h-100" style={{'backgroundColor': 'rgb(var(--primary-dark))'}}></div>
            <img
                className="absolute radius shadow-elevated login-img" 
                src={login}
            />
        </div>
    )
}